import { FC, useMemo, useCallback } from 'react'
import styles from 'components/features/socialFeed/FeedTrendingTags/FeedTrendingTags.styl'
import { useShallowSelector, useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { tagsByTrendSelector } from 'selectors/feedSelectors'
import { TagWithFollow } from 'components/features/socialFeed/FeedfilterPopup/FollowedTagsItem'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { tagsByTrendGuard } from 'guards/feedGuards'
import { EmptyCardBlockWithCta } from 'components/features/pfm/Blocks/Blocks'
import { getFeedTagsActionCreator } from 'actions/feedActions'
import { LoadingOverlay } from 'components/atoms/preloaders/LoadingOverlay'
import { FeedSearchForm } from 'components/features/socialFeed/FeedSearchForm/FeedSearchForm'
import { FORM_TAG_SEARCH } from 'constants/forms'
import { FEED_TRENDING_TAGS_LIMIT } from 'constants/feed'
import { isMobileSelector } from 'selectors/viewportSelectors'

type FeedTrendingTagsProps = {

}

const FeedTrendingTagsComponent: FC<FeedTrendingTagsProps> = (props) => {
  const {} = props

  const tagsWithRequest = useShallowSelector(tagsByTrendSelector)
  const isMobile = useStoreSelector(isMobileSelector)

  const dispatch = useStoreDispatch()
  const handleTryAgain = useCallback(() => {
    dispatch(getFeedTagsActionCreator.request({
      ordering: '-trend',
      limit: FEED_TRENDING_TAGS_LIMIT,
    }))
  }, [dispatch])

  const titleChild = useMemo(() => {
    if (!isMobile) {
      return null
    }

    return (
      <div className={ styles.header }>
        Trending Tags
      </div>
    )
  }, [isMobile])

  const loadingChild = useMemo(() => {
    if (tagsWithRequest && tagsWithRequest.isLoading) {
      return (
        <LoadingOverlay key='loading' isTransparent />
      )
    }

    return null
  }, [tagsWithRequest])

  const tagsChildren = useMemo(() => {
    if (!tagsWithRequest) {
      return null
    }

    if (tagsWithRequest.errorCode) {
      return (
        <EmptyCardBlockWithCta
          text='Something went wrong. Please try again later.'
          buttonText='Try Again'
          onClick={ handleTryAgain }
        />
      )
    }

    if (!tagsWithRequest.payload) {
      return null
    }

    return tagsWithRequest.payload.map((tag) => {
      return (
        <div
          key={ tag.name }
          className={ styles.tagWrapper }
        >
          <TagWithFollow
            { ...tag }
          />
        </div>
      )
    })
  }, [tagsWithRequest, handleTryAgain])

  return (
    <div className={ styles.feedTrendingTags }>
      { titleChild }
      { tagsChildren }
      { loadingChild }
      <div className={ styles.searchWrapper }>
        <FeedSearchForm form={ FORM_TAG_SEARCH } />
      </div>
    </div>
  )
}

export const FeedTrendingTags = connectShadedLoadable<
  {}, {}, FeedTrendingTagsProps
>(() => () => ({}), () => ({}), [tagsByTrendGuard])(FeedTrendingTagsComponent)
